module.exports = __webpack_public_path__ + "static/img/作品21.eec798f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品21.png
// module id = vKwh
// module chunks = 1